<script>
/* update */
import { editorState } from "@app/store/editorStore.svelte.js";
import { eventGroupState } from "@app/store/eventGroupStore.svelte.js";
import { projectState } from "@app/store/projectStore.svelte.js";
import { insertHistoryAction } from "@app/store/historyStore.svelte.js";
import insertEvent from "@cclib/functions/eventGroups/insertEvent.js";
import convertToHtml from "@cclib/functions/quill/convertToHtml.js";
import * as m from '@app/paraglide/messages.js';
const splitEvent = function () {
    try {
        let range = window?.quillEditor?.getSelection();
        let length = window.quillEditor.getLength();
        let frameGap = 0;

        if (
            range &&
            range.index < length - 1 &&
            eventGroupState[projectState.selected].selected.length > 0
        ) {
            let start =
                eventGroupState[projectState.selected].events[
                    eventGroupState[projectState.selected].selected[0]
                ].start;
            let end =
                eventGroupState[projectState.selected].events[
                    eventGroupState[projectState.selected].selected[0]
                ].end;

            

            let duration = end - start;
            let newEventEnd = start + duration / 2;

            if (editorState.minFrameGap > 0) {
                frameGap = editorState.minFrameGap/projectState.frameRate;
            }

            

            /* Split the event */
            if (window.quillEditor) {
                window.quillEditor.setSelection(
                    range.index,
                    window.quillEditor.getLength(),
                );
                document.execCommand("cut");
                navigator.clipboard.readText().then((text) => {
                    // console.log(text);
                    // console.log(convertToHtml(text));
                    let options = {
                        ...eventGroupState[projectState.selected].events[
                            eventGroupState[projectState.selected].selected[0]
                        ],
                        text: convertToHtml(text),
                        start: newEventEnd,
                        end: end,
                    };

                    eventGroupState[projectState.selected].events[
                        eventGroupState[projectState.selected].selected[0]
                    ].end = newEventEnd - frameGap;

                    eventGroupState[projectState.selected] = insertEvent(
                        eventGroupState[projectState.selected],
                        options,
                        eventGroupState[projectState.selected].selected[0] + 1,
                    );
                });

                insertHistoryAction({
                    name: "split event", //action name
                    eventGroup: projectState.selected,
                    snapshots: [
                        {
                            store: "eventGroupState",
                            value: JSON.stringify(eventGroupState),
                        },
                    ],
                });
            }
        }
    } catch (err) {
        console.log(err, err.message);
    }
};
</script>

<li class="nav-item" role="none" title={m.split_event_label()}>
    <a
        class="nav-link"
        href="#!/"
        onclick={splitEvent}
        role="button"
        id="split-event-btn"
        aria-label={m.split_event_label()}
        class:disabled={!eventGroupState[projectState.selected] ||
            eventGroupState[projectState.selected].selected.length !== 1}
        aria-disabled={!eventGroupState[projectState.selected] ||
            eventGroupState[projectState.selected].selected.length !== 1}>
        <i class="bi bi-view-stacked" aria-hidden="true"></i>
        <i class="bi bi-chevron-expand small" aria-hidden="true"></i>
    </a>
</li>
